export default {
	root: {
		fontFamily: 'FustatMedium',
		fontSize: 16,
		lineHeight: 1.2,
		letterSpacing: '-0.02em',
		color: '#302E2A',
	},
	headingBox: {
		display: 'flex',
		justifyContent:'space-between',
		alignItems: 'center'
	},
	h1: { 
		mt: 0,
		mb: { xs: 0.5, sm: 1 },
		fontFamily: 'IvyPrestoHeadlineRegular',
		fontSize: '35px',
		lineHeight: 1.2,
		letterSpacing: '0.03em',
		color: '#302E2A',
	},
}